<template>
  <div class="member-multi-select">
    <label v-for="m in members" :key="m.id" class="row" @click="toggle(m.id)">
      <van-checkbox :value="value.includes(m.id)" shape="square" />
      <MemberAvatar :member="m" :size="22" />
      <span class="name">{{ m.name }}</span>
      <span v-if="m.isPlaceholder" class="tag-chip">佔位</span>
    </label>
  </div>
</template>

<script>
import MemberAvatar from './MemberAvatar.vue'

export default {
  name: 'MemberMultiSelect',
  components: { MemberAvatar },
  props: {
    value: { type: Array, default: () => [] },
    members: { type: Array, required: true }
  },
  methods: {
    toggle (id) {
      const next = this.value.includes(id) ? this.value.filter(v => v !== id) : [...this.value, id]
      this.$emit('input', next)
    }
  }
}
</script>

<style scoped>
.member-multi-select {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 4px;
}
.name { font-size: 14px; }
</style>
